module.exports = __webpack_public_path__ + "img/ltkplussize-4x.25c8a7d.jpg";